<template>
  <div class="text-input-component">
    <div
      class="text-input-wrapper cursor-text flex"
      :class="{
        column: !slim,
        focus: inputWraperFocused,
        'add-shadow': focusShadow && inputWraperFocused,
        disabled,
        slim: slim,
      }"
      @click="focusInput" >
      <!-- <ScrollArea
        ref="inputScrollArea"
        class="input-scroll-area"
        :scroll-offset="13"
        @bottom="scrollToBottom"
        @top="scrollToTop" > -->
      <MessageInputTextarea
        ref="newOutboundMessage"
        v-model="messageContent"
        :prevent-submit="hideSendButton"
        :disabled="disabled"
        :slim="slim"
        :allow-enter-newline="true"
        :recalculate-tag-numbers="tagCounterMode"
        :placeholder="placeholder"
        :maxlength="maxlength"
        @formatting="formatButtonsState"
        @gotFocus="gotFocus"
        @lostFocus="lostFocus"
        @textInserted="scrollToLastPosition"
        @tag-count="tagCounterUpdate"
        @raw-input="rawInput"
        @tab="tabPressed" />
      <!-- </ScrollArea> -->
      <div
        v-if="!hideTools"
        class="tools flex"
        @click.stop="focusInput">
        <span
          class="format flex greedy justify-end" >
          <SBIcon
            v-if="enableFormatButtons"
            :id="`bold-it-btn-${random}`"
            :active="boldActive"
            :icon="SBIconList.FORMAT_B"
            :color="SBColors.blackUltralight"
            :hover-color="SBColors.greyChatBubble"
            :hover-icon-color="SBColors.blackPrimary"
            :hover-size="24"
            :size="12"
            @click="boldIt" />
          <SBIcon
            v-if="enableFormatButtons"
            :id="`italic-it-btn-${random}`"
            :active="italicActive"
            :icon="SBIconList.FORMAT_I"
            :color="SBColors.blackUltralight"
            :hover-color="SBColors.greyChatBubble"
            :hover-icon-color="SBColors.blackPrimary"
            :hover-size="24"
            :size="12"
            @click="italicIt" />
          <SBIcon
            v-if="enableFormatButtons"
            :id="`strike-it-btn-${random}`"
            :active="strikeActive"
            :icon="SBIconList.FORMAT_S"
            :color="SBColors.blackUltralight"
            :hover-color="SBColors.greyChatBubble"
            :hover-icon-color="SBColors.blackPrimary"
            :hover-size="24"
            :size="12"
            @click="strikethroughIt" />
          <SBIcon
            v-if="enableEmoji"
            :id="`emoji-btn-${random}`"
            :icon="SBIconList.EMOJI"
            :color="SBColors.blackUltralight"
            :hover-icon="SBIconList.EMOJI_COLOR"
            :hover-color="SBColors.greyChatBubble"
            :hover-size="24"
            :mask-hover="false"
            :size="12"
            @click="toggleEmoji" />
          <SBIcon
            v-if="showTagsSelect && !tagCounterMode"
            :id="`tag-btn-${random}`"
            :icon="SBIconList.ADD_TAG"
            :color="SBColors.blackUltralight"
            :hover-color="SBColors.greyChatBubble"
            :hover-icon-color="SBColors.blackPrimary"
            :hover-size="24"
            :size="12"
            @click.native.stop
            @click="toggleTagDropdown" />
          <span
            v-if="showTagsSelect && tagCounterMode"
            :id="`number-tag-${random}`"
            class="number-tag flex center-all show-hand"
            @click.stop
            @click="newNumberedTag" >
            <span class="number">{{ tagPlaceholders + 1 }}</span>
          </span>
        </span>
      </div>
    </div>
    <picker
      v-if="showEmojiPicker"
      v-click-outside="closeEmojis"
      class="emoji-picker"
      set="emojione"
      title="Pick your emoji..."
      emoji="point_up"
      :native="true"
      @select="emojiSelected" />
    <!-- WA popover -->
    <b-popover
      :target="`bold-it-btn-${random}`"
      triggers="hover"
      placement="top"
      custom-class="basic-popover flex-body" >
      Bold
    </b-popover>
    <b-popover
      :target="`italic-it-btn-${random}`"
      triggers="hover"
      placement="top"
      custom-class="basic-popover flex-body" >
      Italic
    </b-popover>
    <b-popover
      :target="`strike-it-btn-${random}`"
      triggers="hover"
      placement="top"
      custom-class="basic-popover flex-body"
      boundary="viewport" >
      Strikethrough
    </b-popover>
    <b-popover
      :target="`emoji-btn-${random}`"
      triggers="hover"
      placement="top"
      custom-class="basic-popover flex-body"
      boundary="viewport" >
      Emoji
    </b-popover>
    <b-popover
      :target="`tag-btn-${random}`"
      triggers="hover"
      placement="top"
      custom-class="basic-popover flex-body"
      boundary="viewport" >
      Variable
    </b-popover>
    <b-popover
      :target="`number-tag-${random}`"
      triggers="hover"
      placement="top"
      custom-class="basic-popover flex-body"
      boundary="viewport" >
      Placeholder
    </b-popover>

    <!-- tag dropdown -->
    <b-dropdown
      id="tagdropdown"
      ref="tagDropdownRef"
      no-caret
      right
      @hide="tagDropdownHide" >
      <template #button-content>
        <b-button
          ref="tagDropdownBtn"
          style="display: none !important;">_</b-button>
      </template>
      <b-dropdown-header>
        Contact info
      </b-dropdown-header>
      <b-dropdown-item
        @click="addTagToTextBlock('contact_name')" >Contact name</b-dropdown-item>
      <b-dropdown-header>
        Number info
      </b-dropdown-header>
      <b-dropdown-item
        @click="addTagToTextBlock('number_name')" >Number name</b-dropdown-item>
      <b-dropdown-header>
        Contact fields
        <Spinner
          v-if="loadingCustomFields"
          class="my-3"
          :size="18"
          :thickness="2" />
      </b-dropdown-header>
      <b-dropdown-item
        v-for="(tag, index) in customFieldList[currentOrganisation.id]"
        :key="index"
        @click="addTagToTextBlock(tag.name)" >{{ tag.name }}</b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { Picker } from 'emoji-mart-vue';

import ScrollArea from '@/components/common/ScrollArea';
import SBIcon from '@/components/common/Icon';
import SBIconList from '@/helpers/lists/sb-icon-list';
import SBColors from '@/helpers/lists/colors';
import MessageInputTextarea from '@/components/business/chat/partials/MessageInputTextarea';
import Permissions from '@/mixins/Permissions';
import { quillFormatMessage } from '@/helpers/stringHelpers';
import Spinner from '@/components/common/Spinner';
import randomString from '@/helpers/randomString';

export default {
  name: 'SBTextInput',
  components: {
    Picker,
    SBIcon,
    ScrollArea,
    MessageInputTextarea,
    Spinner,
  },
  mixins: [Permissions],
  props: {
    value: {
      type: String,
      required: false,
      default: '',
    },
    /** Slim type should have buttons in line with input. Use it only when you have one or two buttons. */
    slim: {
      type: Boolean,
      required: false,
      default: false,
    },
    hideTools: {
      type: Boolean,
      required: false,
      default: false,
    },
    maxlength: {
      type: Number,
      required: false,
      default: null,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    focusShadow: {
      type: Boolean,
      required: false,
      default: false,
    },
    hideTemplateButton: {
      type: Boolean,
      required: false,
      default: false,
    },
    hideFileButton: {
      type: Boolean,
      required: false,
      default: false,
    },
    hideAudioButton: {
      type: Boolean,
      required: false,
      default: false,
    },
    hideSendButton: {
      type: Boolean,
      required: false,
      default: false,
    },
    hideQuickReplyButton: {
      type: Boolean,
      required: false,
      default: false,
    },
    /** Shows the formating buttons - bold, italic, strike through */
    enableFormatButtons: {
      type: Boolean,
      required: false,
      default: true,
    },
    /** Shows the emoji button */
    enableEmoji: {
      type: Boolean,
      required: false,
      default: true,
    },
    /** Moves all buttons (including formatting buttons) to the right of the input box. */
    allActionsToRight: {
      type: Boolean,
      required: false,
      default: false,
    },
    // if used you must provide business ID for which the tags will be retrived
    showTagsSelect: {
      type: Boolean,
      required: false,
      default: false,
    },
    businessId: {
      type: String,
      required: false,
      default: '',
    },
    // Shows tag button as auto incremented numbers
    tagCounterMode: {
      type: Boolean,
      required: false,
      default: false,
    },
    placeholder: {
      type: String,
      required: false,
      default: null,
    },
    noTags: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      boldActive: false,
      inputWraperFocused: false,
      italicActive: false,
      lastScrollPos: 0,
      messageContent: '',
      messageContentWithTagsRecalculated: '',
      recordingInProgress: false,
      showEmojiPicker: false,
      showEmojiPicker2: false,
      strikeActive: false,
      blockTagSelectDropdown: false,
      tagPlaceholders: 0,
      defaultCustomFields: [
        {
          value: 'contact_name',
          name: 'Contact name',
        },
        {
          value: 'number_name', // On submit this should be business_name
          name: 'Number name',
        },
      ],
      SBIconList,
      SBColors,
      random: randomString(),
    };
  },
  computed: {
    ...mapGetters({
      customFieldList: 'contact/customFieldList',
      loadingCustomFields: 'contact/loadingCustomFields',
      currentOrganisation: 'organisation/currentOrganisation',
    }),
  },
  watch: {
    messageContent() {
      if (!this.messageContent && this.messageContent !== '') {
        return;
      }
      this.$emit('input', this.messageContent);
      this.messageContentWithTagsRecalculated = this.messageContent.toString();
      const tagsMatch = new RegExp(/<code>(.*?)<\/code>/, 'g');
      const matches = this.messageContent.match(tagsMatch) || [];
      matches.forEach((m) => {
        const match = m.match(/<code>(.*?)<\/code>/);
        let targetValue = '';
        const targetDefaultField = this.defaultCustomFields.find(df => df.name.toLowerCase() === match[1].toLowerCase());
        if (targetDefaultField) {
          targetValue = targetDefaultField.value;
        } else {
          targetValue = match[1].replaceAll(/\s+/g, '_');
        }
        this.messageContentWithTagsRecalculated = this.messageContentWithTagsRecalculated
          .replace(m, `{{${targetValue}}}`)
          .replaceAll(/\{\{number_name\}\}/g, '{{business_name}}');
      });
    },
    value() {
      this.messageContent = this.value;
    },
  },
  mounted() {},
  methods: {
    ...mapActions({}),
    addTagToTextBlock(text) {
      this.$refs.newOutboundMessage.addTag(text);
    },
    toggleTagDropdown() {
      if (!this.blockTagSelectDropdown) {
        this.$refs.tagDropdownBtn.click();
      }
    },
    tagDropdownHide() {
      this.blockTagSelectDropdown = true;
      setTimeout(() => {
        this.blockTagSelectDropdown = false;
      }, 200);
    },
    noFocusTagDropdown() {
      this.$refs.tagDropdownRef.hide(false);
    },
    /**
     * Initiates bold formatting in the message input editor.
     */
    boldIt() {
      this.$refs.newOutboundMessage.boldIt();
    },
    closeEmojis() {
      this.showEmojiPicker = false;
    },
    /**
     * Callback which triggers when emoji is selected.
     *
     * @param emoji Emoji object
     */
    emojiSelected(emoji) {
      this.showEmojiPicker = false;
      this.$refs.newOutboundMessage.addAtLastCaretPosition(emoji.native);
    },
    /**
     * Initiates italic formatting in the message input editor.
     */
    italicIt() {
      this.$refs.newOutboundMessage.italicIt();
    },
    gotFocus() {
      this.inputWraperFocused = true;
    },
    /**
     * Flags the formating buttons active state if needed based on the current selection.
     *
     * @param activeFormat Quill format object
     */
    formatButtonsState(activeFormats) {
      this.boldActive = activeFormats.bold;
      this.italicActive = activeFormats.italic;
      this.strikeActive = activeFormats.strike;
    },
    /**
     * Records the scroll position so it can rescroll to the same position if needed.
     * It is needed when inserting text(emoji) into vue editor and setting the selection afterwards to be after the inserted text.
     */
    lostFocus() {
      // this.lastScrollPos = this.$refs.inputScrollArea.getScrollPosition();
      this.inputWraperFocused = false;
      this.$emit('blur');
    },
    setText(text) {
      if (typeof text === 'string') {
        text = text.replace('{{business_name}}', '{{number name}}');
        this.$refs.newOutboundMessage.resetTextTo(quillFormatMessage(text, { noTags: this.noTags }));
      }
    },
    resetTextTo(text) {
      this.$refs.newOutboundMessage.resetTextTo(text);
    },
    setHtml(html) {
      this.$refs.newOutboundMessage.setHtml(html);
    },
    scrollToBottom() {
      // this.$refs.inputScrollArea.scrollToBottom();
    },
    /**
     * Scrolls the editor to its last known position.
     */
    scrollToLastPosition() {
      // this.$refs.inputScrollArea.scrollTo(this.lastScrollPos);
    },
    scrollToTop() {
      // this.$refs.inputScrollArea.scrollToTop();
    },
    /**
     * Initiates strikethrough formatting in the message input editor.
     */
    strikethroughIt() {
      this.$refs.newOutboundMessage.strikethroughIt();
    },
    toggleEmoji() {
      this.showEmojiPicker = !this.showEmojiPicker;
    },
    focusInput() {
      this.$refs.newOutboundMessage.focus();
    },
    newNumberedTag() {
      this.$refs.newOutboundMessage.addTag();
    },
    tagCounterUpdate(count) {
      this.tagPlaceholders = count;
      this.$emit('tag-count', this.tagPlaceholders);
    },
    rawInput(ri) {
      this.$emit('raw-input', ri);
    },
    tabPressed() {
      this.$emit('tab');
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  #tagdropdown {
    position: absolute;
    right: 0;
    bottom: 0;

    .dropdown-toggle {
      // display: none;
      border: none !important;
      padding: 0px !important;
      opacity: 0;
    }

    .dropdown-header {
      padding: 10px 12px 3px !important;
      font-size: 12px !important;
      font-weight: 400 !important;
      color: $greyPrimary !important;
    }

    ul.dropdown-menu {
      li {
        .dropdown-item {
          padding: 5px 12px !important;
          font-size: 14px;
          font-weight: 400;
          line-height: 1.2;
          color: $blackPrimary;
        }
      }

      li:last-child {
        margin-bottom: 5px;
      }
    }
  }
}

.number-tag {
  // background: ;
  height: 24px;
  border-radius: 5px;
  padding: 5px 10px 5px 9px;
  cursor: pointer;
  color: $blackUltralight;
  user-select: none;
  position: relative;

  &:before {
    content: '';
    background-color: $blackUltralight;
    mask: url('~@/assets/img/SB-Icons/curly-braces-left.svg') no-repeat center;
    mask-size: auto 12px;
    position: absolute;
    left: 1px;
    top: 0;
    bottom: 0;
    width: 10px;
  }

  &:after {
    content: '';
    background-color: $blackUltralight;
    mask: url('~@/assets/img/SB-Icons/curly-braces-left.svg') no-repeat center;
    mask-size: auto 12px;
    position: absolute;
    transform: rotateZ(180deg);
    right: 2px;
    top: 0;
    bottom: 0;
    width: 10px;
  }

  .number {
    font-size: 10px !important;
  }

  &:hover {
    background-color: $linkHover;
    color: $blackPrimary;

    &:before, &:after {
      background-color: $blackPrimary;
    }
  }
}

.text-input-component {
  position: relative;

  .emoji-picker {
    position: absolute;
    right: 0px;
    z-index: 1000;

    ::v-deep .emoji {
      border: none !important;
    }
  }

  .text-input-wrapper {
    min-height: 110px;
    max-height: 310px;
    border-radius: 5px;
    border: solid 1px $greyBorder;
    overflow: hidden;
    box-shadow: 0 1px 3px 0 rgba(48, 54, 70, 0.1);
    background-color: $white;

    &:hover {
      box-shadow: 0 1px 3px 0 rgb(48 54 70 / 30%);
    }

    &.focus {
      // border: solid 1px $blackPrimary;

      &.add-shadow {
        border: solid 1px $greyBorder;
        box-shadow: 0 0 0 3px #bfdeff !important;
      }
    }

    .input-scroll-area {
      height: 72px;
      padding: 10px 10px 0 10px;
    }

    .tools {
      padding: 6px;
      margin-top: -10px; // to fix padding that has to be added because of grammarly
      .format {
        .sb-icon {
          cursor: pointer;
          margin-right: 4px;
        }

        :last-child {
          margin-right: 0;
        }
      }

      .widgets {
        position: relative;

        .sb-icon {
          cursor: pointer;
          margin-left: 4px;
        }

        .emoji-picker {
          position: absolute;
          bottom: 27px;
        }
      }
    }

    &.disabled, &.disabled.focus {
      background-color: $greyUltralight;
      border: solid 1px $greyBorder;
      box-shadow: unset !important;

      .tools {
        background-color: unset;
        border-top-color: $greyUltralight;
      }
    }

    &.slim {
      min-height: 30px;
      max-height: 30px;

      .tools {
        padding: 0px 2px 0px 2px;
        margin-top: 0px;
        align-self: center;
      }
    }
  }
}
</style>
